import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { Grid, TextField, withStyles } from '@material-ui/core';
import { createStructuredSelector } from 'reselect';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { sanlamVeryDarkBlue } from 'Material-UI/colors';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import MyRefunds from 'containers/AmcDetailsPage/MyRefundsTab/Refunds';
import {
  StyledtBlocWrapper,
  SizedSmallSectionHeader,
  StyledtBlocSearch,
  StyledCaption,
} from 'containers/AmcDetailsPage/MyRefundsTab/styles';
import { translate } from 'helpers/intl';
import messages from 'containers/AmcDetailsPage/messages';
import FilterListIcon from '@material-ui/icons/FilterList';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';

const SearchField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none',
      },
    },
  },
})(TextField);

const MyRefundsTab = (props: {
  intl: IntlShape;
  refunds: any;
  refundDetails: any;
  getRefundAMCDetails: Function;
  beneficiaries: [];
}) => {
  return (
    <GaLoadHOC
      category={EVENT_CATEGORIES.AMC_DETAILS}
      label="Suivi de mes remboursement_Tab 1_Suivi de mes remboursements"
    >
      <StyledtBlocWrapper height="auto">
        <StyledtBlocSearch>
          <Grid
            container
            spacing={2}
            justify="space-between"
            alignItems="center"
          >
            <Grid item xs={12} sm={8}>
              <SizedSmallSectionHeader color={sanlamVeryDarkBlue} weight="bold">
                {translate({ ...messages.lastRefunds }, props)}
              </SizedSmallSectionHeader>
            </Grid>
            <Grid container alignItems="center" spacing={2} xs={12} sm={4}>
              <Grid item xs={8} sm={8}>
                <SearchField
                  InputLabelProps={{
                    shrink: true,
                    style: { border: 'none' },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      </InputAdornment>
                    ),
                    style: { borderRadius: 20, backgroundColor: '#EDEEEE' },
                  }}
                  style={{ border: 'none' }}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid container alignItems="center" xs={4} sm={4}>
                <Grid item xs={6} sm={8}>
                  <StyledCaption>
                    {translate({ ...messages.filter }, props)}
                  </StyledCaption>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <FilterListIcon />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </StyledtBlocSearch>
        <MyRefunds
          refunds={props.refunds}
          refundDetails={props.refundDetails}
          getRefundAMCDetails={props.getRefundAMCDetails}
          beneficiaries={props.beneficiaries}
        />
      </StyledtBlocWrapper>
    </GaLoadHOC>
  );
};
const mapStateToProps = createStructuredSelector<any, {}>({});

const mapDispatchToProps = {};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MyRefundsTab));
